import BookOpenSVG from '@remote-com/norma/icons/book-open.svg';
import JobSearchSVG from '@remote-com/norma/icons/jobs-search.svg';
import { RichText } from 'prismic-reactjs';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from 'remote-com-shared/components/Accordion';
import { Button } from 'remote-com-shared/components/Button';
import { fieldHasContent } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { RichTextBaseStyle } from '@/src/components/shared/RichText';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const QuestionsAccordionItem = styled(AccordionItem)`
  border: none;
  position: relative;
`;

export const AccordionHeaderRelative = styled(AccordionHeader)`
  position: relative;
`;

export const AccordionItemQuestion = styled.div`
  padding-left: calc(var(--spacingX) + var(--spacingXOffset));
  margin-left: calc((var(--spacingX) + var(--spacingXOffset)) * -1);
`;

export const AccordionItemIcon = styled.div`
  position: absolute;
  left: calc((var(--spacingX) + var(--spacingXOffset)) * -1);
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 12px 0 12px 16px;
  border-radius: 50px 0 0 50px;

  ${tabletBreakpoint(css`
    left: -34px;
    transform: translate(-5%, -50%);
    padding-left: 4px;
  `)}

  ${({ $tone }) => {
    switch ($tone) {
      case 'light':
        return css`
          background-image: none;
          background-color: var(--colors-blank);
        `;
      default:
        return css`
          background-color: var(--colors-linkWater);
        `;
    }
  }}
`;

const QuestionsAccordionButton = styled(Button)`
  ${fluidProp(['margin-top'], '0px', '20px')}

  && {
    min-width: auto;
  }
`;

export const SingleQuestionAccordionItem = styled(QuestionsAccordionItem)`
  --spacingX: 20px;
  --spacingXOffset: 10px;
  padding: 24px var(--spacingX);
  padding-left: calc(var(--spacingX) + var(--spacingXOffset));
  border-radius: 10px;

  ${tabletBreakpoint(css`
    margin-left: 10px;
  `)}

  ${({ $tone }) => {
    switch ($tone) {
      case 'light':
        return css`
          background-image: none;
          background-color: var(--colors-blank);
        `;
      default:
        return css`
          background-color: var(--colors-linkWater);
        `;
    }
  }}
`;

export const RichTextWrapper = styled.div`
  ${RichTextBaseStyle}
  --textHighlightColor: var(--colors-irisBlue);
  --textHighlightSecondaryOpacity: 0.4;
`;

export function QuestionsAndConsiderations({ question, answer, ctaText, ctaLink, tone, icon }) {
  return (
    <>
      <Accordion collapsible multiple>
        <SingleQuestionAccordionItem $tone={tone}>
          <AccordionHeaderRelative>
            <AccordionItemQuestion>{question}</AccordionItemQuestion>
            <AccordionItemIcon $tone={tone}>
              {icon === 'search' ? (
                <JobSearchSVG fill="var(--colors-irisBlue)" />
              ) : (
                <BookOpenSVG fill="var(--colors-irisBlue)" />
              )}
            </AccordionItemIcon>
          </AccordionHeaderRelative>
          <AccordionPanel>
            <RichText render={answer} Component={RichTextWrapper} />
            {fieldHasContent(ctaLink) && fieldHasContent(ctaText) && (
              <QuestionsAccordionButton tone="primary" href={ctaLink}>
                {ctaText}
              </QuestionsAccordionButton>
            )}
          </AccordionPanel>
        </SingleQuestionAccordionItem>
      </Accordion>
    </>
  );
}
